(function() {
/* eslint-disable no-extend-native, no-global-assign, new-cap */
'use strict';

// Replaces string vars by argument index+1
// i.e. {0} is replaced by second argument
String.format = function(...args) {
    const tokenised = args[0];
    return tokenised.replace(/{[0-9]}/g, function(matched) {
        matched = matched.replace(/[{}]/g, '');
        return args[parseInt(matched) + 1];
    });
};

// Replaces string vars by name
// i.e. String.supplant('Hi {name}', {name: 'abc'}); //'Hi abc'
Object.defineProperty(String, 'supplant', {
    enumerable: false,
    configurable: false,
    value(str, o) {
        // http://javascript.crockford.com/remedial.html
        return str.replace(/\{([^{}]*)\}/g, function(a, b) {
            const r = o[b];
            return typeof r === 'string' || typeof r === 'number' ? r : a;
        });
    }
});

//polyfill because phantom js does not currently support bind which is annoying
Function.prototype.bind || (Function.prototype.bind = function(thisp) {
    return (...args) => this.apply(thisp, args);
});

// This polyfill adds forEach compatibility to all Browsers supporting ES5
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

//date polyfills which seem to be necessary for android 2.3.x and maybe others
const supportsExtendedYears = Date.parse('+033658-09-27T01:46:40.000Z') === 1e15;
const acceptsInvalidDates = !isNaN(Date.parse('2012-04-04T24:00:00.500Z')) || !isNaN(Date.parse('2012-11-31T23:59:59.000Z'));
const doesNotParseY2KNewYear = isNaN(Date.parse('2000-01-01T00:00:00.000Z'));

if (!Date.parse || doesNotParseY2KNewYear || acceptsInvalidDates || !supportsExtendedYears) {
    // XXX global assignment won't work in embeddings that use
    // an alternate object for the context.
    Date = (function(NativeDate) {
        // Date.length === 7
        function Date(...args) {
            const [Y, M, D, h, m, s, ms] = args;
            const length = args.length;
            if (this instanceof NativeDate) {
                const date = length === 1 && String(Y) === Y ? // isString(Y)
                    // We explicitly pass it through parse:
                    new NativeDate(Date.parse(Y)) :
                    // We have to manually make calls depending on argument
                    // length here
                    length >= 7 ? new NativeDate(Y, M, D, h, m, s, ms) :
                    length >= 6 ? new NativeDate(Y, M, D, h, m, s) :
                    length >= 5 ? new NativeDate(Y, M, D, h, m) :
                    length >= 4 ? new NativeDate(Y, M, D, h) :
                    length >= 3 ? new NativeDate(Y, M, D) :
                    length >= 2 ? new NativeDate(Y, M) :
                    length >= 1 ? new NativeDate(Y) :
                                  new NativeDate();
                // Prevent mixups with unfixed Date object
                date.constructor = Date;
                return date;
            }
            return NativeDate(...args);
        }

        // 15.9.1.15 Date Time String Format.
        const isoDateExpression = new RegExp('^' +
            '(\\d{4}|[+-]\\d{6})' + // four-digit year capture or sign +
                                      // 6-digit extended year
            '(?:-(\\d{2})' + // optional month capture
            '(?:-(\\d{2})' + // optional day capture
            '(?:' + // capture hours:minutes:seconds.milliseconds
                'T(\\d{2})' + // hours capture
                ':(\\d{2})' + // minutes capture
                '(?:' + // optional :seconds.milliseconds
                    ':(\\d{2})' + // seconds capture
                    '(?:(\\.\\d{1,}))?' + // milliseconds capture
                ')?' +
            '(' + // capture UTC offset component
                'Z|' + // UTC capture
                '(?:' + // offset specifier +/-hours:minutes
                    '([-+])' + // sign capture
                    '(\\d{2})' + // hours offset capture
                    ':(\\d{2})' + // minutes offset capture
                ')' +
            ')?)?)?)?' +
        '$');

        const months = [
            0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365
        ];

        function dayFromMonth(year, month) {
            const t = month > 1 ? 1 : 0;
            return (
                months[month] +
                Math.floor((year - 1969 + t) / 4) -
                Math.floor((year - 1901 + t) / 100) +
                Math.floor((year - 1601 + t) / 400) +
                365 * (year - 1970)
            );
        }

        function toUTC(t) {
            return Number(new NativeDate(1970, 0, 1, 0, 0, 0, t));
        }

        // Copy any custom methods a 3rd party library may have added
        for (const key in NativeDate) {
            Date[key] = NativeDate[key];
        }

        // Copy "native" methods explicitly; they may be non-enumerable
        Date.now = NativeDate.now;
        Date.UTC = NativeDate.UTC;
        Date.prototype = NativeDate.prototype;
        Date.prototype.constructor = Date;

        // Upgrade Date.parse to handle simplified ISO 8601 strings
        Date.parse = function parse(...args) {
            const string = args[0];
            const match = isoDateExpression.exec(string);
            if (match) {
                // parse months, days, hours, minutes, seconds, and milliseconds
                // provide default values if necessary
                // parse the UTC offset component
                const year = Number(match[1]);
                const month = Number(match[2] || 1) - 1;
                const day = Number(match[3] || 1) - 1;
                const hour = Number(match[4] || 0);
                const minute = Number(match[5] || 0);
                const second = Number(match[6] || 0);
                const millisecond = Math.floor(Number(match[7] || 0) * 1000);
                // When time zone is missed, local offset should be used
                // (ES 5.1 bug)
                // see https://bugs.ecmascript.org/show_bug.cgi?id=112
                const isLocalTime = Boolean(match[4] && !match[8]);
                const signOffset = match[9] === '-' ? 1 : -1;
                const hourOffset = Number(match[10] || 0);
                const minuteOffset = Number(match[11] || 0);
                let result;
                if (
                    hour < (
                        minute > 0 || second > 0 || millisecond > 0 ?
                        24 : 25
                    ) &&
                    minute < 60 && second < 60 && millisecond < 1000 &&
                    month > -1 && month < 12 && hourOffset < 24 &&
                    minuteOffset < 60 && // detect invalid offsets
                    day > -1 &&
                    day < (
                        dayFromMonth(year, month + 1) -
                        dayFromMonth(year, month)
                    )
                ) {
                    result = (
                        (dayFromMonth(year, month) + day) * 24 +
                        hour +
                        hourOffset * signOffset
                    ) * 60;
                    result = (
                        (result + minute + minuteOffset * signOffset) * 60 +
                        second
                    ) * 1000 + millisecond;
                    if (isLocalTime) {
                        result = toUTC(result);
                    }
                    if (-8.64e15 <= result && result <= 8.64e15) {
                        return result;
                    }
                }
                return NaN;
            }
            return NativeDate.parse(...args);
        };

        return Date;
    })(Date);
}


// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

if (/GT-I9195|GT-I9000/.test(navigator.userAgent)) {
    /*
        FIX for [ GalaxyS4-Mini (GT-I9195) | S3 (GT-I9000) ]
        It seems that, for some reason, the samsung stock browser can't handle correctly
        a change in the page dimension. To solve this the function binded to the touchmove
        event checks if the user is at the bottom of the page. If this is not the case a
        repaint is forced by moving the scroll down by one pixel (the movement is not visible)
        this way the dimensions of the page are recalculated by webkit.
        The "+ 2" has been inserted because a miscalculation of a single pixel can happen
        while comparing the left side of the formula with the scrollHeight (this should not affect
        the user experience).
     */
    document.body.addEventListener('touchmove', function() {
        //  Scroll Position    + Visibile page      + 2 < total dimension of the page
        if (window.pageYOffset + window.innerHeight + 2 < document.body.scrollHeight) {
            scrollTo(0, window.pageYOffset + 1);
        }
    }, false);
}
})();
